$shm_projects_tasks_panel $shm_service_task_list
	sort_by? \created
	sort_order? \desc
	Sort_menu $mol_pick
		hint \Сортировка задач
		trigger_content /
			<= Menu_trigger_icon $mol_icon_dots_vertical
		bubble_content /
			<= Sort $shm_sort
				sort_by? <=> sort_by?
				sort_order? <=> sort_order?
				options *
					created \Дата создания
					updated \Дата редактирования
